module.exports = __webpack_public_path__ + "img/human-in-hands.064817c.svg";